import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { rootReducers } from "./reducers";

const bindWithMiddleware = (middleware) => {
  if (process.env.NODE_ENV !== "production") {
    const { composeWithDevTools } = require("redux-devtools-extension");
    return composeWithDevTools(applyMiddleware(...middleware));
  }
  return applyMiddleware(...middleware);
};

const store = createStore(rootReducers, bindWithMiddleware([thunk]));

export default store;
